import React from 'react';

import { Container, Description } from './styles';

interface TeamPeopleProps {
  name: string;
  prole: string;
  image: string;
}

const TeamPeople: React.FC<TeamPeopleProps> = ({
  name,
  prole,
  image,
}: TeamPeopleProps) => {
  return (
    <Container>
      <img src={image} alt="People" />
      <Description>
        <p>{name}</p>
        <span>{prole}</span>
      </Description>
    </Container>
  );
};

export default TeamPeople;
